import { useThemeSurfaces } from "../../theme/useThemeSurfaces"

export interface MetricCardProps {
  label: string
  value: number | string
  unit?: string
  comparison?: {
    value: number
    label: string
  }
  trend?: "up" | "down" | "neutral"
  className?: string
}

const trendColors = {
  up: "#31d0aa",
  down: "#ff2b4f",
  neutral: "var(--muted)",
}

const trendIcons = {
  up: "▲",
  down: "▼",
  neutral: "─",
}

export function MetricCard({ label, value, unit, comparison, trend, className }: MetricCardProps) {
  const { panel } = useThemeSurfaces()

  return (
    <div
      className={className}
      style={{
        background: panel.secondary.background,
        border: panel.secondary.border,
        boxShadow: panel.secondary.shadow,
        padding: "16px",
      }}
    >
      <div
        className="mono"
        style={{
          fontSize: "10px",
          letterSpacing: "0.15em",
          textTransform: "uppercase",
          color: "var(--muted)",
          marginBottom: "8px",
        }}
      >
        {label}
      </div>

      <div
        className="mono"
        style={{
          fontSize: "32px",
          fontWeight: 500,
          color: "var(--text)",
        }}
      >
        {value}
        {unit && <span style={{ fontSize: "18px" }}>{unit}</span>}
      </div>

      {comparison && trend && (
        <div
          className="mono"
          style={{
            marginTop: "8px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "11px",
          }}
        >
          <span style={{ color: trendColors[trend] }}>{trendIcons[trend]}</span>
          <span style={{ color: "var(--muted)" }}>
            {Math.abs(Number(value) - comparison.value)}
            {unit} vs {comparison.label}
          </span>
        </div>
      )}
    </div>
  )
}
